import { GQL } from '../graphQl'

export const CreateCustomListQuery = () => GQL`mutation CreateCustomListQuery(
  $data: [custom_list_values_insert_input!]!,
  $name: String
  ) {
  insert_core_custom_list(
    objects: {custom_list_values: {data: $data}, name: $name}
  ) {
    affected_rows
  }
}
`
export const ResourceStateValueCountQuery = () => GQL`query ResourceStateValueCountQuery($id: Int) {
  core_material_master(where: {resource_state_value: {id: {_eq: $id}}}) {
    material_name
  }
}
`
export const MaterialTypeCountQuery = () => GQL`query MaterialTypeCountQuery($id: Int) {
  core_material_master(where: {material_type: {_eq: $id}}) {
    material_name
  }
}`
export const GetResourceGroupCountQuery = () => GQL`query getResourceGroupCountQuery($id: Int) {
  core_material_master(where: {resource_group: {_eq: $id}}) {
    material_name
  }
}
`
export const GetActiveCustomListsQuery = () => GQL`query GetActiveCustomListsQuery {
  core_custom_list(where: {deleted: {_eq: false}, tenant_id: {_is_null: false}},order_by: {updated_on : desc}) {
    name
    id
    system_generated
    created_on
    updated_on
    template_fields(where:{template_version:{active:{_eq:true}}}){
    field_id
   }
    custom_list_values_aggregate(where: {deleted: {_eq: false}}){
    aggregate{
    count}}
  }
}
`

export const GetPaginatedActiveCustomListsQuery = () => GQL`query GetPaginatedActiveCustomListsQuery($limit: Int, $offset: Int, $where: core_custom_list_bool_exp!, $orderBy: [core_custom_list_order_by!]) {
  core_custom_list(
    where: {_and: [{deleted: {_eq: false}}, {tenant_id: {_is_null: false}}, $where]}, 
    order_by: $orderBy, 
    limit: $limit, 
    offset: $offset
  ) {
    name
    id
    system_generated
    created_on
    updated_on
    id_generation_rules {
      id
    }
    template_fields(where: {template_version: {active: {_eq: true}}}) {
    field_id
   }
    custom_list_values_aggregate(where: {deleted: {_eq: false}, parent_id: {_is_null: true}}) {
    aggregate{
    count(columns: id)}}
  }
}
`
export const GetTaskStatusQuery = () => GQL`query getTaskStatusQuery {
  custom_list_values(
    where: {deleted: {_eq: false}, custom_list: {name: {_eq: "Task Status"}}}
  ) {
    id
    name
  }
}`

export const GetCustomListQuery = () => GQL`query GetCustomListQuery($id: Int!) {
  core_custom_list_by_pk(id: $id) {
    name
    id
    custom_list_values(where: {deleted: {_eq: false}, parent_id:{_is_null:true}} order_by: {order_index: asc }) {
      editable
      deleted
      id
      parent_id
      abbreviation
      name
      child_values_aggregate(where:{deleted:{_eq:false}}) {
        aggregate {
          count(columns: id)
        }
      }
    }
  }
}`

export const GetPaginatedCustomListQuery = () => GQL`query GetPaginatedCustomListQuery($id: Int!, $limit: Int, $offset: Int, $conditions: custom_list_values_bool_exp!) {
  core_custom_list_by_pk(id: $id) {
    name
    id
    custom_list_values(
      where: $conditions
      order_by: {order_index: asc }
      limit: $limit
      offset: $offset
    ) {
      editable
      deleted
      id
      parent_id
      abbreviation
      name
      child_values_aggregate(where:{deleted:{_eq:false}}) {
        aggregate {
          count(columns: id)
        }
      }
    }
  }
}`

export const GetCustomListChildQuery = () => GQL`query GetCustomListQuery($id: Int!) {
    custom_list_values(where: {deleted: {_eq: false}, parent_id:{_eq:$id}} order_by: {name: asc, editable: asc}) {
      editable
      deleted
      id
      parent_id
      abbreviation
      name
      child_values_aggregate(where:{deleted:{_eq:false}}) {
        aggregate {
          count(columns: id)
        }
      }
    }
}`

export const GetPaginatedCustomListChildQuery = () => GQL`query GetPaginatedCustomListChildQuery($id: Int!, $limit: Int, $offset: Int, $search: String = "%%") {
    custom_list_values(
      where: { 
        deleted: { _eq:false }, 
        parent_id: {_eq:$id},
        name: {_ilike: $search}
      } 



      order_by: {order_index: asc}
      limit: $limit
      offset: $offset
    ) {
      editable
      deleted
      id
      parent_id
      abbreviation
      name
      child_values_aggregate(where:{deleted:{_eq:false}}) {
        aggregate {
          count(columns: id)
        }
      }
    }
}`
// here you can pass array of custom list ids
export const GetCustomListsQuery = () => GQL`query GetCustomListsQuery($ids: [Int!]) {
  core_custom_list(where: {id: {_in: $ids}}) {
    id
    name
    custom_list_values (where: {deleted: {_eq: false}} order_by: {name: asc, editable: asc}){
      editable
      deleted
      id
      name
      abbreviation
    }
  }
}`
export const UpdateUnitOfMaterialQuery = () => GQL`mutation changeDefaultValue($oldId: Int, $newId: Int) {
  update_core_material_master(
    where: {unit_of_material: {_eq: $oldId}}
    _set: {unit_of_material: $newId}
  ) {
    affected_rows
  }
}`

export const materialCustomListUpdateQuery = () => GQL`mutation changeDefaultValue($oldId: Int, $newId: Int) {
  update_core_material_master(
    where: {material_group: {_eq: $oldId}}
    _set: {material_group: $newId}
  ) {
    affected_rows
  }
}`

export const ResourceStateQuery = () => GQL`query fetchingResourceState {
  custom_list_values(
    where: {custom_list: {name: {_eq: "Resource State"}}, deleted: {_eq: false}}
  ) {
    id
    name
  }
}`

export const getStatusAssociatedTaskCount = () => GQL`query getStatusAssociatedTaskCountQuery($id: Int){
  core_tasks_aggregate(where: {status: {_eq: $id}}) {
    aggregate {
      count(columns: id)
    }
  }
}
`

export const changeDefaultValueQuery = () => GQL`mutation changeDefaultValue($oldId: Int, $newId: Int) {
  update_core_tasks(where: {status: {_eq: $oldId}}, _set: {status: $newId}) {
    affected_rows
  }
}`

export const DeleteCustomListQuery = () => GQL`mutation delete_custom_list($id:Int!) {
  delete_custom_list_values(where: {custom_list_id: {_eq: $id}}) {
    affected_rows
  }
  delete_core_custom_list(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
`

export const UpdateCustomListQuery = () => GQL`mutation update_custom_list($id: Int!, $data: core_custom_list_set_input!) {
  update_core_custom_list_by_pk(_set: $data, pk_columns: {id: $id}) {
    id
  }
}
`

export const CreateCustomListValuesQuery = () => GQL`mutation create_custom_list_values($data: [custom_list_values_insert_input!]!) {
  insert_custom_list_values(objects:$data, on_conflict: {
    constraint: custom_list_values_name_custom_list_id_parent_id_key
    update_columns: deleted, where: {deleted: {_eq: true}}}) {
    affected_rows
  }
}
`
export const UpdateCustomListValuesQuery = () => GQL`mutation update_custom_list_values($id: Int!,$data:custom_list_values_set_input!) {
  update_custom_list_values_by_pk(
    _set: $data,
    pk_columns: {id: $id}
  ) {
    id
  }
} 
`

export const ChangeOrderCustomListValuesQuery = () => GQL`mutation ChangeOrder($valueId: Int!, $newPos: Int!) {
  reorder_custom_list_values(custom_list_value_id: $valueId, new_pos: $newPos) {
    message
  }
}
`

export const DeleteCustomListValuesQuery = () => GQL`mutation delete_custom_list_values($id: Int!) {
  update_custom_list_values(
    where: {
      _or: [
        { id: { _eq: $id } },
        { parent_id: { _eq: $id } }
      ]
    }
    _set: { deleted: true }
  ) {
    affected_rows
  }
}
`

export const validateCustomListQuery = () => GQL`query validateCustomListQuery(
  $name: String
  ) {
    core_custom_list(where: {name: {_ilike: $name}, deleted: {_eq: true}}) {
      id
    }
  }`

export const getAttachedMaterialCountQuery = () => GQL`query getAttachedMaterialCountQuery($id: Int) {
  core_material_master(where: {material_group: {_eq: $id}}) {
    material_name
  }
}`

export const GetUnitOfMaterialCountQuery = () => GQL`query GetUnitOfMaterialCountQuery($id: Int) {
  core_material_master(where: {unit_of_material: {_eq: $id}}) {
    material_name
  }
}`
export const GetMaterialElementQuery = () => GQL`query GetMaterialElementQuery {
  custom_list_values(
    where: {deleted: {_eq: false}, custom_list: {name: {_eq: "Element Priority"}}}
  ) {
    id
    name
  }
}`

export const CreateCustomListImportQuery = () => GQL`mutation ImportCustomListValues($has_header: Boolean!, $mapping: jsonb!, $custom_list_id: Int!, $blob_key: String!, $parent_id: Int) {
  import_custom_list_values(has_header: $has_header, mapping: $mapping, blob_key: $blob_key, custom_list_id: $custom_list_id, parent_id: $parent_id) {
    message
  }
}`

export const CheckTopLevelCustomListValueByAbbreviationQuery =
  () => GQL`query CheckTopLevelCustomListValueByAbbreviationQuery($custom_list_id: Int!, $abbreviation: String!) {
  custom_list_values(
    where: {custom_list_id: {_eq: $custom_list_id}, parent_id: {_is_null: true}, abbreviation: {_ilike: $abbreviation}}
    order_by: {order_index: asc}
  ) {
    id
    name
    deleted
    abbreviation
  }
}`

export const CheckChildTopLevelCustomListValueByAbbreviationQuery = () => GQL`query CheckChildTopLevelCustomListValueByAbbreviationQuery($custom_list_id: Int!, $abbreviation: String!, $parent_id: Int) {
  custom_list_values(
    where: {custom_list_id: {_eq: $custom_list_id}, parent_id: {_eq: $parent_id}, abbreviation: {_ilike: $abbreviation}}
    order_by: {order_index: asc}
  ) {
    id
    name
    deleted
    abbreviation
  }
}`

export const CheckTopLevelCustomListValueByNameQuery = () => GQL`query CheckTopLevelCustomListValueByNameQuery($custom_list_id: Int!, $name: String!) {
  custom_list_values(
    where: {
      custom_list_id: {_eq: $custom_list_id},
      parent_id: {_is_null: true},
      name: {_ilike: $name}
    }
  ) {
    id
    name
    deleted
    abbreviation
  }
}`

export const CheckChildTopLevelCustomListValueByNameQuery = () => GQL`query CheckChildTopLevelCustomListValueByNameQuery($custom_list_id: Int!, $name: String!, $parent_id: Int) {
  custom_list_values(
    where: {
      custom_list_id: {_eq: $custom_list_id},
      parent_id: {_eq: $parent_id},
      name: {_ilike: $name}
    } order_by: {order_index: asc}
  ) {
    id
    name
    deleted
    abbreviation
  }
}`

export const CopyCustomListValuesQuery = () => GQL`mutation CopyCustomListValues($targetCustomListId: Int!, $targetParentId: Int, $valueIds: [Int!]!) {
  copy_custom_list_values(
    target_custom_list_id: $targetCustomListId
    target_parent_id: $targetParentId
    value_ids: $valueIds
  ) {
    new
    revived
already_exists {
      id
      name
      abbreviation
      parent_id
      source_name
      source_abbreviation
      deleted
    }
  }
}
 `
